import React from "react";
import { Nav } from "react-bootstrap";

import { Skeleton, OnlineLink } from "components";
import { useLoader } from "hooks";
import { ApplicationNavProps } from "types";

import styles from "./applicationList.module.scss";

let ApplicationNav = ({ counters, isCountersLoading }: ApplicationNavProps) => {
	const Loader = useLoader(isCountersLoading);

	const tabs = [
		{
			title: "All Applications",
			to: "/applications/all",
			eventKey: "all",
		},
		{
			title: "Signed MPAs",
			to: "/applications/signed-mpas",
			eventKey: "signed-mpas",
			counters: `${counters?.signedMPACount}`,
		},
		{
			title: "Pre-Applications",
			to: "/applications/pre-applications",
			eventKey: "pre-applications",
			counters: `${counters?.preApplicationCount}`,
		},
		{
			title: "Pended",
			to: "/applications/pended",
			eventKey: "pended",
			counters: `${counters?.pendApplicationCount}`,
		},
		{
			title: "Drafts",
			to: "/applications/drafts",
			eventKey: "drafts",
		},
	];

	return (
		<Nav variant="tabs">
			{tabs.map(t => (
				<Nav.Item
					key={`link-${t.title}`}
					className={styles.appNavLinkItem}
				>
					<Nav.Link
						as={OnlineLink}
						to={t.to}
						eventKey={t.eventKey}
						className={styles.appNavLink}
					>
						{t.title}
						{t?.counters && (
							<Loader
								skeleton={
									<Skeleton
										className={styles.skeletonForCounters}
									/>
								}
								component={
									<div
										className={`${
											styles.appNavLinkCounter
										} text-${
											t.eventKey === "pended"
												? "warning"
												: "info"
										} `}
									>
										({t.counters})
									</div>
								}
							/>
						)}
					</Nav.Link>
				</Nav.Item>
			))}
		</Nav>
	);
};

export default ApplicationNav;
